export const DEFAULT_REGION = {
  id: '5',
  name: 'Warsaw',
}
export const DEFAULT_SECTION_SLUG = 'main-page-top'

export const COOKIE = {
  LOCATION: 'location',
  NEXT_LOCALE: 'NEXT_LOCALE',
  ADULT: 'adult',
  OPTANON_CONSENT: 'OptanonConsent',
  ALERT_BOX_CLOSED: 'OptanonAlertBoxClosed',
}

export enum FESTIVAL_PATH_NAMES {
  rw = 'restaurantweek',
  bw = 'breakfastweek',
  fdw = 'finediningweek',
}

export enum MARKETS {
  pl = 'pl',
  cz = 'cz',
  de = 'de',
}

export enum SimpleSectionOrientation {
  LEFT_TITLE = 'left-title',
  RIGHT_TITLE = 'right-title',
}
